import React from 'react';
import { Dialog, Text, Flex } from '@leverege/ui-elements';
import { MapControl } from '@leverege/ui-mapbox-elements';
import { Geocoder } from '@leverege/ui-geo-elements';
import I18N from '@leverege/i18n';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.views.CenterOnAddressInput');
async function onSubmit({
  data: props,
  value = {}
}) {
  const {
    onClose,
    mapName = 'map'
  } = props;
  const {
    position,
    bbox
  } = value;
  if (bbox && mapName) {
    MapControl.flyToBounds(mapName, bbox);
  } else if (position && mapName) {
    MapControl.flyTo(mapName, {
      ...position,
      zoom: 16
    });
  }
  if (onClose) onClose();
}
export default function CenterOnAddressInput(props) {
  const {
    focus,
    hint = t('hint'),
    icon = tIcon('icon', 'fa fa-search fa-fw')
  } = props;
  const iView = /*#__PURE__*/_jsx("i", {
    className: icon,
    style: {
      marginLeft: '8px'
    }
  });
  return /*#__PURE__*/_jsx(Geocoder, {
    focus: focus,
    icon: iView,
    eventData: props,
    hint: hint,
    onChange: onSubmit
  });
}
CenterOnAddressInput.Dialog = function (props) {
  const {
    onClose,
    show
  } = props;
  return /*#__PURE__*/_jsx(Dialog.Message, {
    title: t('title'),
    show: show,
    closeOnEscape: true,
    closeOnDocumentClick: true,
    onClose: onClose,
    okayVariant: "secondary",
    okay: "Cancel",
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: "colM",
      children: [/*#__PURE__*/_jsx(Text, {
        variant: "caption",
        children: t('message')
      }), /*#__PURE__*/_jsx(CenterOnAddressInput, {
        focus: true,
        ...props
      })]
    })
  });
};